import {Component, Injector, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../../../Dialog-types/base-dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ALLOWED_URL_SCHEMES} from '../../../../Definitions/shared.definitions';

import { ClickOutsideDirective } from '../../../../../Directives/clickOutside.directive';

@Component({
    selector: 'ins-balloon-preview-dialog',
    templateUrl: './balloon-preview-dialog.component.html',
    styleUrls: ['./balloon-preview-dialog.component.css', './../../shared-dialogs-ui.scss',
        './../../../../UI-Components/shared-UI-components.scss'],
    imports: [ClickOutsideDirective]
})
export class BalloonPreviewDialogComponent extends BaseDialog implements OnInit {
  private readonly _firstClickOutside: boolean = true;
  safePath: SafeResourceUrl;
  
  @Input() path: string; // Always receive plain string URLs
  @Input() type: string;
  @Input() specificType: string = '';
  @Input() width: number = 200;
  @Input() height: number = 200;
  
  constructor(public injector: Injector, private readonly sanitizer: DomSanitizer) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.path?.includes(':') && !ALLOWED_URL_SCHEMES.test(this.path)) {
      console.warn('BalloonPreviewDialog: blocked potentially unsafe URL scheme:', this.path);
      this.safePath = '';
    } else {
      this.safePath = this.sanitizer.bypassSecurityTrustResourceUrl(this.path); // NOSONAR - URL scheme validated against ALLOWED_URL_SCHEMES allowlist
    }
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['path', this.path],
      ['type', this.type],
      ['specificType', this.specificType],
      ['width', this.width],
      ['height', this.height]
    );
  }

  onChanges(): void {
  }

  // we need this method to overcome the following issue:
  // this dialog is opened by clicking the screen. this first click will enter the "clickOutside" directive of this component.
  // To avoid closing the dialog on open, we will ignore the first time the directive fires the "clickOutside" event.
  // for now- this isn't happening
  handleClickOutside(): void {
    // if (this._firstClickOutside) {
    //   this._firstClickOutside = false;
    //   return;
    // }
    this.close('close');
  }
}
